import styled, { css } from 'styled-components/macro'

import { settings } from '../../../styled/settings/index';
import { mixins } from '../../../styled/mixins/index';
import { tabletLandscapeUp } from '../../../styled/settings/mediaqueries';

const {
  colors: { color, hexToRGBa },
  mediaqueries: { desktopUp, mobileDown, tabletLandscapeDown, tabletPortraitDown, tabletPortraitUp },
  sizing: { spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  layout: { centered, fullContainerBackgroundImage, pageSection, pageSectionInner },
  typography: { buttonText, heading1, heading2, heading5, heroDescription, linkButtonText },
} = mixins;

export const CameraImage = styled.img`
  width: 4rem;
  height: 4rem;
  z-index: 1;
  float: right;
  position: relative;
  right: 2rem;
  margin-top: -6rem;
`;